export enum EScheduleAvailabilityType {
  WITH_PREVIOUS_SCHEDULES = "WITH_PREVIOUS_SCHEDULES",
  WITH_USAGE_GUIDE = "WITH_USAGE_GUIDE",
  ALL = "ALL",
}
